module.exports = {"searchResponse.warning":"Žádný subjekt jsme pod tímto výrazem nenašli.","searchResponse.error":"Chyba při vyhledávaní subjektů"}